import { render, staticRenderFns } from "./Rater.vue?vue&type=template&id=8edb0faa"
import script from "./Rater.vue?vue&type=script&lang=js"
export * from "./Rater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports